module.exports = __webpack_public_path__ + "img/cacc-logo.204ea17b.jpg";